import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { DEFAULT_AUDIENCE_ITEMS } from '../public/AudienceNav';

/**
 * The four audience links (Deals · For Businesses · For Venues · Pricing) for the mobile
 * drawer, shown to signed-in users under SLOT_MODEL (MobileNav): on a phone the Header's
 * AudienceNav is hidden (md and up only), and the signed-in drawer otherwise has no way to
 * For Businesses / For Venues. Same items as the desktop nav; NavLink sets aria-current.
 * Styled for the drawer's navy panel with tokens only (white on navy, navy on white).
 */
export default function MobileNavAudienceLinks({ onClose, items = DEFAULT_AUDIENCE_ITEMS, label = 'Explore Tappd' }) {
  return (
    <nav aria-label={label} className="mb-5">
      <ul className="grid grid-cols-2 gap-2">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              onClick={onClose}
              className={({ isActive }) => cn(
                'flex min-h-11 items-center justify-center rounded-xl px-3 text-center font-body text-sm font-semibold transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy',
                isActive ? 'bg-white text-navy' : 'bg-white/10 text-white hover:bg-white/20',
              )}
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
